export default __webpack_public_path__ + "static/media/MaterialBelongings.56b2415d.mp3";